import { Component, Input, ViewChild } from '@angular/core';
import { CanvasItem } from '../../clases/CanvasItem';
import { CdkMenu, CdkMenuModule } from '@angular/cdk/menu';
import { MatMenu, MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { Overlay } from '@angular/cdk/overlay';
import { Values } from '../../clases/Values';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { INeo4j } from '../../interfaces/Neo4j';
import { ShapeRefArray } from '../../clases/ShapeRefArray';
import { ConnectionRef } from '../../clases/ConnectionRef';
import { AbstractShape } from '../../abstract/Shape';

export enum N4JCMAction { DELETE_NODE, CREATE_NODE, CREATE_RELATIONSHIP, DELETE_RELATIONSHIP, SAVE_CONTAINER_AS_VIEW, REMOVE_FROM_VIEW, REMOVE_ONLY_THIS_FROM_VIEW }

@Component({
  selector: 'neo4j-context-menu',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    CdkMenuModule,
    MatMenuModule,
    MatChipsModule,
    FormsModule,
    MatIconModule
  ],
  templateUrl: './neo4j-context-menu.component.html',
  styleUrl: './neo4j-context-menu.component.scss'
})
export class Neo4jContextMenuComponent {
  @ViewChild('menu', { static: false }) menu!: MatMenu;

  nodeName: string = "";
  labelName: string = "";
  relationType: string = "";
  constructor(private overlay: Overlay){}

  stepNumber: number = 1;

  // selected: CanvasItem|undefined;

  isConnetion: boolean = false;

  viewSteps: number = 0;

  @ViewChild('menuTrigger') menuTrigger!: MatMenuTrigger;
  @Input() document!: INeo4j;
  @Input() selectedShape!: ShapeRefArray;
  @Input() selectedRelation!: ConnectionRef;
  @Input() callback!: Function;

  currentShape!: AbstractShape;

  ngOnInit(): void {
    this.currentShape = this.selectedShape.getShape()[0];
  }

  ngAfterViewInit(): void {
    this.menu.closed.subscribe(()=>{
      this.resetMenu();
    });
  }

  preventPropagation(event: any){
    event.preventDefault();
    event.stopPropagation();
  }

  onAddNode(event: any){
    this.preventPropagation(event);
    // if(this.selected){
    //   if(this.selected.getRelationType()){
    //     this.stepNumber = 3;
    //     return;
    //   }
    //   this.stepNumber++;
    //   return;
    // }
    // this.stepNumber = 3;
    this.stepNumber = 4;
  }

  onNode(event: any){
    this.preventPropagation(event);
    let responseJson = {
      nodeName: this.nodeName,
      labelName: this.labelName,
      type: N4JCMAction.CREATE_RELATIONSHIP,
      relation: this.relationType,
    };
    this.callback(responseJson);
    this.onCloseContextMenu();

    // if(this.isConnetion){
    //   // this.appComponent.onConnection(this.selected!, this.relationType);
    //   this.onCloseContextMenu();
    //   return
    // }
    // this.stepNumber++;
  }

  onChip(event: any){
    this.preventPropagation(event);
    this.stepNumber++;
  }

  onSelectRelationType(event: any){
    this.preventPropagation(event);
    this.stepNumber = 5;
  }

  onCreateNode(event: any){
    this.preventPropagation(event);
    let responseJson = {
      nodeName: this.nodeName,
      labelName: this.labelName,
      type: N4JCMAction.CREATE_NODE
    };
    this.callback(responseJson);
    this.onCloseContextMenu();
  }

  removeNodeView(event: any){
    this.preventPropagation(event);
    this.viewSteps = 2;
  }

  removeNodeViewKeepChildren(event: any){
    this.preventPropagation(event);
    this.viewSteps = 3;
  }

  onRemoveFromView(event: any){
    this.preventPropagation(event);
    let responseJson = {
      node: this.selectedShape.getShape()[0],
      type: N4JCMAction.REMOVE_FROM_VIEW
    };
    this.callback(responseJson);
    this.onCloseContextMenu();
  }

  onRemoveOnlyThisFromView(event: any){
    this.preventPropagation(event);
    let responseJson = {
      node: this.selectedShape.getShape()[0],
      type: N4JCMAction.REMOVE_ONLY_THIS_FROM_VIEW
    };
    this.callback(responseJson);
    this.onCloseContextMenu();
  }

  onCloseContextMenu(){
    this.resetMenu();
    this.menuTrigger.closeMenu();
  }

  resetMenu(){
    this.viewSteps = 0;
    this.stepNumber = 1;
    this.isConnetion = false;
  }

  onDeleteNode(event: any){
    this.preventPropagation(event);
    this.stepNumber = 5;
  }

  deleteNode(event: any){
    this.preventPropagation(event);
    let responseJson = {
      node: this.selectedShape.getShape()[0],
      type: N4JCMAction.DELETE_NODE
    };
    this.callback(responseJson);
    this.onCloseContextMenu();
  }

  canDeleteNode(){
    if(!this.selectedShape.getShape()[0].dbData) return true;
    let labels = this.selectedShape.getShape()[0].getLabels();
    if(typeof labels === "string"){
      if(labels === "CLASS") return false;
    }

    for (const label of labels) {
      if(label === "CLASS") return false;
    }
    
    return true;
  }

  deleteRelation(event: any){
    this.preventPropagation(event);
    let responseJson = {
      node: this.selectedRelation,
      type: N4JCMAction.DELETE_RELATIONSHIP
    };
    this.callback(responseJson);
    this.onCloseContextMenu();
  }

  onConnetion(event: any){
    this.isConnetion = true;
    // this.stepNumber = 2;
    this.onNode(event);
  }

  removeChild(list: CanvasItem[], item: CanvasItem){
    const index = list.indexOf(item, 0);
    if (index > -1) {
      list.splice(index, 1);
    }
  }

  onClose(event: any){
    this.preventPropagation(event);
    this.onCloseContextMenu();
  }

  onContainer(event: any){
    this.preventPropagation(event);
    this.viewSteps = 1;
  }

  onCreateView(event: any){
    this.preventPropagation(event);
    let responseJson = {
      node: this.selectedShape.getShape()[0],
      type: N4JCMAction.SAVE_CONTAINER_AS_VIEW,
      name: this.nodeName
    };
    this.callback(responseJson);
    this.onCloseContextMenu();
  }

  openMenu(position: Values) {
    this.menuTrigger.openMenu();
    const overlayRef = this.menuTrigger['_overlayRef']; // Access the overlayRef

    if (overlayRef) {
      overlayRef.updatePositionStrategy(
        this.overlay
          .position()
          .flexibleConnectedTo({ x: position.x, y: position.y })
          .withPositions([
            {
              originX: 'start',
              originY: 'top',
              overlayX: 'start',
              overlayY: 'top',
            },
          ])
      );
    }
  }

}
